import styled from "styled-components";

//TODO: Remove this during the My Meals overhaul
//Order Flow cart button could probably be reused
const CustomCartIcon = styled.img`
  height: 40px;
  width: 40px;
`;

export default CustomCartIcon;
